import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import { RootState, store } from '../..';
import { Activity, UpdateActivityParam } from '@/models/activity/activity';
import { CreateActivityParam } from '@/models/activity/activity';
import { ActivityItemCategory } from '@/models/activity/activity';
import { activityService } from '@/service/api/activity.service';

export interface IActivityState {
  activities: Activity[]; // アクティビティ（自身の所属している学校のものと JTB作成のもの）
  activityItemCategories: ActivityItemCategory[]; // マスタ：アクティビティアイテムカテゴリー
  createActivityEntity: CreateActivityParam;
}
@Module({ dynamic: true, store, name: 'activityModule', namespaced: true })
class ActivityModule extends VuexModule implements IActivityState {
  activities: Activity[] = [];
  activityItemCategories: ActivityItemCategory[] = [];
  createActivityEntity: CreateActivityParam = new CreateActivityParam();
  createActivityName: string = '';


  get toActivity(): (activityID: number) => Activity {
    return (activityID: number) => this.activities.find((activity: Activity) => activity.activityID === activityID);
  }


  @Mutation
  setActivities(value: Activity[]) {
    this.activities = value;
  }

  @Mutation
  setActivityItemCategories(value: ActivityItemCategory[]) {
    this.activityItemCategories = value;
  }

  @Mutation
  setCreateActivityName(value: string) {
    this.createActivityName = value;
  }

  /**
   * アクティビティ一覧取得
   */
  @Action({ rawError: true })
  async fetchActivities(): Promise<Activity[]> {
    const activities: Activity[] = await activityService.getActivities();
    this.setActivities(activities);
    return activities;
  }

  /**
   * アクティビティカテゴリー（含むアイテム）一覧取得
   */
  @Action({ rawError: true })
  async fetchCategoriesWithItem(): Promise<ActivityItemCategory[]> {
    const activityItemCategories: ActivityItemCategory[] = await activityService.getCategoriesWithItem();
    this.setActivityItemCategories(activityItemCategories);
    return activityItemCategories;
  }

  /**
   * 新規作成:アクティビティ
   */
  @Action({ rawError: true })
  async createActivity() {
    this.createActivityEntity.activityName = this.createActivityName;
    this.createActivityEntity.activityItems = this.activityItemCategories.map((category) => { return category.selectedItems }).flat();
    await activityService.createActivity(this.createActivityEntity);
  }

  /**
   * 更新:アクティビティ
   */
  @Action({ rawError: true })
  async updateActivity(act: UpdateActivityParam) {
    await activityService.updateActivity(act);
  }

  /**
   * 削除:アクティビティ
   */
  @Action({ rawError: true })
  async deleteActivity(id: number) {
    await activityService.deleteActivity(id);
  }
}

export const activityModule = getModule(ActivityModule);
